module.exports = __webpack_public_path__ + "img/verde-oscuro.c34c24be.svg";